//////////////////////////////////////////////////////////////////////////
//																		//
//						ENQUETE STUDIO WASSINK							//
//																		//
//////////////////////////////////////////////////////////////////////////


// SETTING UP THE GLOBALS ///////////////////////////////////////////////////////////////////////////
let   rowOne = document.getElementById('rij1'),
	  rowTwo = document.getElementById('rij2'),
	  rowThree = document.getElementById('rij3'),
	  rowOneTitle = document.getElementById('rij1-title'),
	  rowTwoTitle = document.getElementById('rij2-title'),
	  rowThreeTitle = document.getElementById('rij3-title'),
	  resultOne = document.getElementById('resultOne'),
	  resultTwo = document.getElementById('resultTwo'),
	  resultThree = document.getElementById('resultThree'),
	  standardLink = 'https://www.bloomsandblossoms.eu/collections/',
	  resultLink = document.getElementById('link'),
	  step = document.getElementById('steps'),
	  keuzes = document.getElementById('keuzehulp-keuzes'),
	  startKnop = document.getElementById('keuzehulp-start'),
	  titel = document.getElementById('keuzehulp-titel'),
	  backbtn = document.getElementById('back-btn');


// START ///////////////////////////////////////////////////////////////////////////////////////////

function startNew () {

	startKnop.classList.add("hide");

	titel.classList.add("show-now");
	titel.classList.remove("hide");	

	rowOne.classList.remove("hide");
	rowOneTitle.classList.remove("hide");
	rowOne.classList.add("show-now");
	rowOneTitle.classList.add("show-now");

	step.classList.add("show-now");
	step.classList.remove("hide");

	
}

// HANDLING QUESTION ONE ///////////////////////////////////////////////////////////////////////////
function getAnswerOne(id) {

	let currentQuestion = document.getElementById(id).id;
	console.log(currentQuestion);

	if ( currentQuestion.includes("vraag1") === true) {
	 	var answerOne = document.getElementById(id).getAttribute('value');
		console.log(answerOne);

		resultOne.innerText = answerOne;
		step.innerText = 'Stap 2/3';

		rowOne.classList.add("hide");
		rowOneTitle.classList.add("hide");

		rowTwo.classList.remove("hide");
		rowTwo.classList.add("show-now");
		rowTwoTitle.classList.remove("hide");
		rowTwoTitle.classList.add("show-now");

		return globalThis.answerOne = answerOne;
		return globalThis.resultOne = resultOne;
	 }
 }

// HANDLING QUESTION TWO ///////////////////////////////////////////////////////////////////////////
 function getAnswerTwo(id) {

	let currentQuestion = document.getElementById(id).id;
	console.log(currentQuestion);

	if ( currentQuestion.includes("vraag2") === true) {
	 	var answerTwo = document.getElementById(id).getAttribute('value');
		console.log(answerTwo);

		resultTwo.innerText = answerTwo;
		step.innerText = 'Stap 3/3';

		rowTwo.classList.add("hide");
		rowTwoTitle.classList.add("hide");

		rowThree.classList.remove("hide");
		rowThreeTitle.classList.remove("hide");
		rowThree.classList.add("show-now");
		rowThreeTitle.classList.add("show-now");		

		return globalThis.answerTwo = answerTwo;
	 }
 }


 // HANDLING QUESTION THREE ///////////////////////////////////////////////////////////////////////////
  function getAnswerThree(id) {

	let currentQuestion = document.getElementById(id).id;
	console.log(currentQuestion);

	if ( currentQuestion.includes("vraag3") === true) {
	 	var answerThree = document.getElementById(id).getAttribute('value');
		console.log(answerThree);

		resultThree.innerText = answerThree;

		rowThree.classList.add("hide");
		rowThreeTitle.classList.add("hide");


		document.getElementById('linktext').innerText = 'Klik hier voor het overzicht';
		resultLink.classList.remove("hide");
		resultLink.classList.add("show-now");
		//CREATE THE LINK
		resultLinkURL = standardLink + answerThree + '/' + answerOne + '+' + answerTwo;
		console.log(resultLinkURL);
		let collectionLink = document.createElement('a', );
		resultLink.appendChild(collectionLink);
		resultLink.setAttribute('href', resultLinkURL);

		

		keuzes.classList.add("show-now");
		keuzes.classList.remove("hide");

		backbtn.classList.add("show-now");
		backbtn.classList.remove("hide");
		

		return globalThis.answerThree = answerThree;


	 }
 }


// DELETE INPUT ///////////////////////////////////////////////////////////////////////////
 function back() {

 	console.log('Wis')
 	rowTwo.classList.add("hide");
 	rowThree.classList.add("hide");
 	rowTwoTitle.classList.add("hide");
 	rowThreeTitle.classList.add("hide");

 	rowOne.classList.remove("hide");
 	rowOneTitle.classList.remove("hide");
 	rowOne.classList.add("show-now");
 	rowOneTitle.classList.add("show-now"); 	

	resultOne.innerText = 'keuze 1';
	resultTwo.innerText = 'keuze 2';
	resultThree.innerText = 'keuze 3';

	keuzes.classList.add("hide");

	//step.innerText = 'Stap 1/3';

	document.getElementById('linktext').innerText = standardLink;
	document.getElementById('link').classList.add("hide");

	return globalThis.answerOne = answerOne;
	return globalThis.resultOne = resultOne;
}

// EINDE KEUZEHULP ////////////////////////////////////////////////////////////////////////////////////////////